// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"1d62c28d","987":"1d62c28d"}[chunkId] + ".chunk.css";
};